<template>
  <div v-if="visible">
    <div :style="{margin: '0px 30px 15px', paddingTop: '20px',fontSize: '15px'}">
      <p :style="{color: 'white'}">
        <b>{{ message }}</b>
      </p>
    </div>
    <a-spin
      :spinning="spinning"
      tip="Loading..."
    >
      <div
        class="innerbox"
        :style="{borderRadius: '5px',height:'530px',margin: '0px 30px',backgroundColor: 'white',color:'black',overflow:'auto'}"
      >
        <div
          :style="{padding: '15px 30px'}"
          id="questionId"
        >
          <!-- 单项选择 -->
          <single-form
            ref="single"
            @resultChange="resultChange"
          ></single-form>
          <!-- 语法填空 -->
          <fill-form
            ref="fill"
            @resultChange="resultChange"
          ></fill-form>
          <!-- 完形填空     -->
          <choice-form
            ref="choice"
            @resultChange="resultChange"
          ></choice-form>
          <!-- 阅读理解 -->
          <read-form
            ref="read"
            @resultChange="resultChange"
          ></read-form>
          <!-- 阅读理解 II -->
          <readTwo-form
            ref="readTwo"
            @resultChange="resultChange"
          ></readTwo-form>
        </div>
      </div>
    </a-spin>
    <div :style="{margin: '0px 100px'}">
      <a-row :gutter="48">
        <a-col :span="18">
        </a-col>
        <a-col :span="2">
          <div :style="{margin: '30px 0px'}">
            <a-button
              shape="circle"
              :style="{width: '60px',height: '60px'}"
              @click="lastQuestion(data)"
            >
              <a-icon
                :style="{fontSize: '58px'}"
                type="left-circle"
              />
            </a-button>
          </div>
        </a-col>
        <a-col :span="2">
          <div :style="{margin: '30px 0px'}">
            <a-button
              shape="circle"
              :style="{width: '60px',height: '60px'}"
              @click="nextQuestion(data)"
            >
              <a-icon
                :style="{fontSize: '58px'}"
                type="right-circle"
              />
            </a-button>
          </div>
        </a-col>
        <a-col :span="2">
          <div :style="{margin: '30px 0px'}">
            <a-button
              shape="circle"
              :style="{width: '60px',height: '60px'}"
              @click="onChange"
            >
              <a-icon
                :style="{fontSize: '58px'}"
                type="clock-circle"
              />
            </a-button>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import ChoiceForm from './ChoiceQuestion'
import ReadForm from './ReadQuestion'
import ReadTwoForm from './ReadQuestionTwo'
import FillForm from './FillQuestion'
import SingleForm from './SingleQuestion'
export default {
  name: 'AfterForm',
  components: {
    SingleForm,
    ChoiceForm,
    ReadForm,
    ReadTwoForm,
    FillForm
  },
  data () {
    return {
      visible: false,
      data: {},
      dataOption: [],
      spinning: false,
      message: ''
    }
  },
  methods: {
    onChange () {
      this.visible = false
      this.$emit('answerChange', this.dataOption)
    },
    handleOpen (value) {
      this.spinning = true
      this.dataOption = value
      this.visible = true
      this.message = value[0].title
      setTimeout(() => {
        this.spinning = false
        this.judgeChange(value[0])
      }, 10)
    },
    handleLocation (value) {
      this.visible = true
      setTimeout(() => {
        this.judgeChange(value)
      }, 10)
    },
    judgeChange (value) {
      // console.log('value:' + JSON.stringify(value))
      this.data = value
      this.message = value.title
      // 单项选择
      if (value.type === '1') {
        this.$refs.fill.handleClose()
        this.$refs.read.handleClose()
        this.$refs.readTwo.handleClose()
        this.$refs.choice.handleClose()
        this.$refs.single.handleOpen(value)
      }
      // 语法填空
      if (value.type === '2') {
        this.$refs.single.handleClose()
        this.$refs.choice.handleClose()
        this.$refs.read.handleClose()
        this.$refs.readTwo.handleClose()
        this.$refs.fill.handleOpen(value)
      }
      // 完形填空
      if (value.type === '3') {
        this.$refs.single.handleClose()
        this.$refs.fill.handleClose()
        this.$refs.read.handleClose()
        this.$refs.readTwo.handleClose()
        this.$refs.choice.handleOpen(value)
      }
      // 阅读理解1
      if (value.type === '4') {
        this.$refs.single.handleClose()
        this.$refs.fill.handleClose()
        this.$refs.readTwo.handleClose()
        this.$refs.choice.handleClose()
        this.$refs.read.handleOpen(value)
      }
      // 阅读理解2
      if (value.type === '5') {
        this.$refs.single.handleClose()
        this.$refs.fill.handleClose()
        this.$refs.read.handleClose()
        this.$refs.choice.handleClose()
        this.$refs.readTwo.handleOpen(value)
      }
    },
    // 点击下一题
    nextQuestion (data) {
      this.dataOption.forEach((item, i) => {
        if (data.key === item.key && i < this.dataOption.length - 1) {
          this.judgeChange(this.dataOption[i + 1])
        }
      })
    },
    lastQuestion (data) {
      this.dataOption.forEach((item, i) => {
        if (data.key === item.key && i > 0) {
          this.judgeChange(this.dataOption[i - 1])
        }
      })
    },
    resultChange (item) {
      this.dataOption.forEach((data, i) => {
        if (data.moduleId === item.moduleId) {
          data.option = item.option
        }
      })
    }
  }
}
</script>
<style>
.innerbox::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 4px;
}
.innerbox::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px #f5f5f5;
  background: rgba(0, 0, 0, 0.2);
}
.innerbox::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>
